import data from '@data'

const { DOMAIN_HOSTNAME, ENV_CLIENT_ID } = data

export const getLoginUrl = ({ button, ssoUrl, domain, env }) => {
  if (!button?.url?.url) return null

  const buttonUrl = button.url?.url

  if (buttonUrl) {
    const url = new URL(buttonUrl)

    if (
      url?.hostname?.includes(DOMAIN_HOSTNAME) &&
      url?.pathname?.includes('/login')
    ) {
      const currentUrl =
        typeof window !== 'undefined' && new URL(window.location.href)

      const returnPath = currentUrl?.pathname
      const redirectUri = `${domain}/callback`

      const paramsObj = {
        client_id: ENV_CLIENT_ID[env],
        redirect_uri: redirectUri,
        response_type: 'cookie',
        state: returnPath,
      }

      const urlParams = new URLSearchParams(paramsObj).toString()

      const authorizeUrl = `/authorize?${urlParams}`

      const loginUrl = `${ssoUrl}/login?return_url=${encodeURIComponent(
        authorizeUrl
      )}`

      return loginUrl
    }
  }

  return button.url?.url
}

export const getLoginButtonClick = ({ button }) => {
  if (!button?.url?.url) return null

  const buttonUrl = button.url?.url

  if (buttonUrl) {
    const url = new URL(buttonUrl)

    if (
      url?.hostname?.includes(DOMAIN_HOSTNAME) &&
      url?.pathname?.includes('/login')
    ) {
    }
  }

  return
}
